import React from "react";

import { useToast } from "@kazoohr/confetti";
import {
  ApiClientContext,
  ApolloClient,
  ApolloProvider,
} from "@kazoohr/graphql";

// This file is a duplicate of packages/layout-components/src/ApolloProviders.tsx
// I didn't want to add a dependency on @kazoohr/layout-components just for this

export function ConstellationApolloProviders({
  client,
  children,
}: React.PropsWithChildren<{
  client: ApolloClient;
}>) {
  const { success, error } = useToast();

  return (
    <ApolloProvider client={client}>
      <ApiClientContext.Provider
        value={{
          client,
          defaultOnSuccess: success,
          defaultOnError: error,
        }}
      >
        {children}
      </ApiClientContext.Provider>
    </ApolloProvider>
  );
}
